// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"514":"43f3529a","521":"8fc96e30"}[chunkId] + ".css";
};